import { Box } from "@chakra-ui/react";
import { useEffect } from "react";

export const Ad = ({
  mt,
  slot,
  height = "90px",
  width = "728px",
}: {
  mt: number;
  slot: string;
  height?: string;
  width?: string;
}) => {
  const isDevelopment = window.location.hostname === "localhost";

  useEffect(() => {
    try {
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push(
        {}
      );
    } catch (e) {}
  }, []);

  return (
    <Box mt={mt}>
      <ins
        className="adsbygoogle"
        style={{
          display: "inline-block",
          width: width,
          height: height,
          textAlign: "center",
          backgroundColor: isDevelopment
            ? ["blue", "green", "red", "orange", "purple"][
                Math.floor(Math.random() * 5)
              ]
            : undefined,
        }}
        data-ad-client="ca-pub-3803893620391095"
        data-ad-slot={slot}
      ></ins>
    </Box>
  );
};
